import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "../../components/ui/card";
import { Map, FileText, Table2, Building, Calculator, Shield, Briefcase, MapPin } from "lucide-react";

const submoduloConfig = {
  "ficha-catastral": { title: "Ficha Catastral", icon: FileText, color: "blue" },
  "tabla-pvt": { title: "Tabla PVT", icon: Table2, color: "green" },
  "tabla-tvc": { title: "Tabla TVC", icon: Table2, color: "yellow" },
  "tabla-depreciacion": { title: "Tabla Depreciación", icon: Table2, color: "red" },
  "clasificador-inmuebles": { title: "Clasificador Inmuebles", icon: Building, color: "indigo" },
  "solvencia": { title: "Solvencia Propiedad Inmobiliaria", icon: Shield, color: "cyan" },
  "boletin-calculo": { title: "Boletín de Cálculo", icon: Calculator, color: "purple" },
  "expediente-digital": { title: "Expediente Digital", icon: Briefcase, color: "teal" },
  "mapeo": { title: "Mapeo", icon: MapPin, color: "orange" },
};

const CatastroLanding = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6" data-testid="catastro-page">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
          <Map className="w-6 h-6 text-blue-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>Catastro</h1>
          <p className="text-slate-500">Seleccione un submódulo</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Object.entries(submoduloConfig).map(([key, config]) => {
          const Icon = config.icon;
          return (
            <Card key={key} className="card-hover cursor-pointer group" onClick={() => navigate(`/catastro/${key}`)} data-testid={`submodulo-${key}`}>
              <CardContent className="p-6">
                <div className={`w-12 h-12 bg-${config.color}-100 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className={`w-6 h-6 text-${config.color}-600`} />
                </div>
                <h3 className="font-semibold text-slate-900 mb-1">{config.title}</h3>
                <p className="text-sm text-slate-500">Gestión de {config.title.toLowerCase()}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default CatastroLanding;
